export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 60 },
  { key: '3', headerName: 'Audit Type', field: 'auditType', hide: false, width: 110 },
  {
    key: '4', headerName: 'Audit Number', field: 'audit_id', hide: false, width: 125
  },
  { key: '5', headerName: 'Outlet Name', field: 'outlet_name', hide: false, width: 145 },
  { key: '7', headerName: 'Submission Date', field: 'created_at', hide: false, width: 145 },
  {
    key: '8', headerName: 'Actual Score', field: 'total_mark', hide: false, width: 115
  },
  { key: '9', headerName: 'Status', field: 'Status', hide: false, width: 115 },
  { key: '12', headerName: 'Aging Days', field: 'agingDays', hide: false, width: 125 },
  { key: '10', headerName: 'Ranking (Based on Month)', field: 'catqegory', hide: false, width: 250 },

];
